export function Error404() {
  return <div className="Error container">Not found</div>
}
